/**
 * All page-level lazy imports live here.
 *
 * Convention: each entry maps 1-to-1 to a file in src/pages/.
 * Vite code-splits at each dynamic import() boundary automatically.
 *
 * To add a new page:
 *   1. Create src/pages/<section>/<PageName>/<PageName>.tsx
 *   2. Add a lazy import below
 *   3. Add it to the router in router.tsx
 */
import { lazy } from "react";

// ─── Auth pages ──────────────────────────────────────────────────
export const LoginPage = lazy(() => import("@/pages/auth/LoginPage/LoginPage"));
export const RegisterPage = lazy(
  () => import("@/pages/auth/RegisterPage/RegisterPage"),
);
export const ForgotPasswordPage = lazy(
  () => import("@/pages/auth/ForgotPasswordPage/ForgotPasswordPage"),
);

// ─── Dashboard pages ─────────────────────────────────────────────────
export const CalendarPage = lazy(
  () => import("@/pages/dashboard/calendar/CalendarPage"),
);

export const CompaniesPage = lazy(
  () => import("@/pages/dashboard/companies/CompaniesPage"),
);

export const TeamsPage = lazy(
  () => import("@/pages/dashboard/teams/TeamsPage"),
);

// Shop is now rendered via the generic content page; keep the file for
// backward-compatibility but avoid exporting a top-level ShopPage route.

export const PerformanceRatingPage = lazy(
  () => import("@/pages/dashboard/performance-rating/PerformanceRatingPage"),
);

// ─── Admin pages ─────────────────────────────────────────────────
export const ClusterManagementPage = lazy(
  () => import("@/pages/admin/cluster-management/ClusterManagementPage"),
);
export const DashboardPage = lazy(
  () => import("@/pages/dashboard/DashboardPage/DashboardPage"),
);
export const EventsPage = lazy(
  () => import("@/pages/events/EventsPage/EventsPage"),
);
export const EventDetailPage = lazy(
  () => import("@/pages/events/EventDetailPage/EventDetailPage"),
);
// export const TeamsPage = lazy(
//   () => import("@/pages/teams/TeamsPage/TeamsPage"),
// );
export const SettingsPage = lazy(
  () => import("@/pages/admin/settings/SettingsPage"),
);
export const SquadBuilderPage = lazy(
  () => import("@/pages/admin/squad-builder/SquadBuilderPage"),
);

export const ProductsPage = lazy(
  () => import("@/pages/admin/products/ProductsPage"),
);

export const RequestManagementPage = lazy(
  () => import("@/pages/admin/request-management/RequestManagementPage"),
);

export const InvitedPage = lazy(
  () => import("@/pages/admin/invited/InvitedPage"),
);

export const SpacesPage = lazy(() => import("@/pages/admin/spaces/SpacesPage"));

export const TransactionsPage = lazy(
  () => import("@/pages/admin/transactions/TransactionsPage"),
);

export const CouponsPage = lazy(() => import("@/pages/admin/coupon/Coupon"));

export const CartPage = lazy(() => import("@/pages/dashboard/cart/CartPage"));

export const FixturesPage = lazy(
  () => import("@/pages/dashboard/fixtures/FixturesPage"),
);
// Attendee pages.
export const AttendeesPage = lazy(
  () => import("@/pages/dashboard/attendees/AttendeesPage"),
);

// Other club-specific pages are handled by the generic content renderer.

export const OrdersHistoryPage = lazy(
  () => import("@/pages/dashboard/orders-history/OrdersHistoryPage"),
);

export const RegisterRequestsPage = lazy(
  () => import("@/pages/admin/register-requests/RegisterRequestsPage"),
);

export const LeagueManagementPage = lazy(
  () => import("@/pages/admin/league-management/LeagueManagementPage"),
);

export const ContentsPage = lazy(
  () => import("@/pages/dashboard/content/ContentPage"),
);
export const LabelContentRoute = lazy(
  () => import("@/pages/dashboard/content/LabelContentRoute"),
);

// League onboarding page (added for parity with events-frontend)
export const LeagueOnboardingPage = lazy(
  () => import("@/pages/dashboard/league-onboarding/LeagueOnboardingPage"),
);
